import Api from './Api'
import { GLOBAIS_BASE_URL } from '../Const/webConst'

const ApiGlobais = (base) => Api(`${GLOBAIS_BASE_URL}/${base}`)

export default ApiGlobais
